<template>
  <div>
    <div
      class="d-flex"
      v-if="
        (filterMatterEvaluations.length > 0 || allows_crud) &&
        institution &&
        institution.internal_use_id == 'duoc.cl'
      "
    >
      <div class="w-100" v-if="work_types.length > 0">
        <b-table-simple bordered>
          <b-thead>
            <b-tr>
              <b-th
                class="work-type-th text-center"
                :colspan="work_types.length"
                >{{
                  $t(
                    "matterProgram.matterProgramView.workTypesOf"
                  ).toUpperCase()
                }}
                {{
                  $getVisibleNames(
                    "evaluations2.evaluation",
                    true,
                    "Evaluaciones"
                  ).toUpperCase()
                }}
                {{
                  $t("matterProgram.matterProgramView.summative").toUpperCase()
                }}
              </b-th>
            </b-tr>
            <b-tr>
              <b-th
                v-for="work_type in work_types"
                :key="'work_type_value:' + work_type.id"
                class="work-type-th"
                >{{ work_type.value }}
              </b-th>
            </b-tr>
            <b-tr>
              <b-td
                v-for="work_type in work_types"
                :key="'work_type_id:' + work_type.id"
                class="work-type-td"
                >{{ totalWeighingByWorkType(work_type.id) }}%
              </b-td>
            </b-tr>
          </b-thead>
        </b-table-simple>
        <!-- <div>
          <div
            v-for="work_type in work_types"
            :key="'work_type:' + work_type.id"
          >
            <strong class="d-flex">
              <span class="mr-2"> {{ work_type.value }}: </span>
              <div class="ml-auto mr-0">
                {{ totalWeighingByWorkType(work_type.id) }}%
              </div>
            </strong>
          </div>
        </div> -->
      </div>
    </div>
    <b-table-simple
      v-if="filterMatterEvaluations.length > 0 || allows_crud"
      small
      responsive
    >
      <b-thead>
        <b-tr>
          <b-th
            :colspan="tableColspan"
            style="text-align: center"
            class="pl-3 evaluation-header"
          >
            {{
              $t(
                "matterProgram.matterProgramView.activitiesAndEvaluations"
              ).toUpperCase()
            }}
            <div class="evaluation-button-div">
              <ButtonMedium
                v-if="
                  allows_crud &&
                  can_update &&
                  egress_profile_matter_id &&
                  institution &&
                  institution.internal_use_id != 'duoc.cl' &&
                  user &&
                  user.is_superuser
                "
                :tooltip_text="``"
                :click_button="openEpmMatterModal"
                :text_button="
                  $t(
                    'matterProgram.matterProgramView.copyEpmMatterModalTitle',
                    {
                      entity: $getVisibleNames(
                        'mesh.egressprofile',
                        false,
                        'Perfil de Egreso'
                      ),
                    }
                  )
                "
                :custom_class="`mr-1`"
                :icon="'files'"
                :variant="'primary'"
              >
              </ButtonMedium>
              <ButtonMedium
                v-if="allows_crud && can_update"
                :tooltip_text="
                  $t(
                    'matterProgram.matterProgramView.createActivityOrEvaluation'
                  )
                "
                :click_button="
                  () =>
                    $bvModal.show(`add-matter-evaluation-modal-${matter_id}`)
                "
                :text_button="$t('reusable.common.create')"
                :custom_class="`mx-1`"
                :icon="'plus'"
                :variant="'primary'"
              >
              </ButtonMedium>
              <!-- <b-button
                v-if="allows_crud"
                class="mx-1"
                size="sm"
                @click="
                  $bvModal.show(`add-matter-evaluation-modal-${matter_id}`)
                "
                >Crear Actividad o Evaluación</b-button
              > -->
            </div>
          </b-th>
        </b-tr>
        <b-tr>
          <b-td
            style="width: 2%"
            class="text-center"
            v-if="
              allows_crud && filterMatterEvaluations.length > 0 && can_update
            "
          >
          </b-td>
          <b-td class="text-center print-nombre">
            <strong>
              {{ $t("reusable.common.name").toUpperCase() }}
            </strong>
          </b-td>
          <b-td
            v-if="
              institution.kl_assessment ||
              (institution && institution.internal_use_id == 'duoc.cl')
            "
            class="text-center print-instrumento"
          >
            <strong
              v-if="institution && institution.internal_use_id != 'duoc.cl'"
            >
              {{
                $getVisibleNames(
                  "evaluations2.test",
                  true,
                  "Instrumentos"
                ).toUpperCase()
              }}
            </strong>
            <strong v-else>
              {{
                $getVisibleNames(
                  "teaching.evaluationsituation",
                  true,
                  "Situación Evaluativa"
                ).toUpperCase()
              }}
            </strong>
          </b-td>
          <b-td
            v-if="isDuocInstitution"
            class="text-center print-descripcion"
            style="width: 20%; min-width: 300px"
          >
            <strong>
              {{ $t("reusable.common.description").toUpperCase() }}
            </strong>
          </b-td>
          <b-td class="text-center print-tipo">
            <strong>
              {{ $t("matterProgram.matterProgramView.type").toUpperCase() }}
            </strong>
          </b-td>
          <b-td class="text-center print-ponderacion">
            <strong>{{
              $t("matterProgram.matterProgramView.weighing").toUpperCase()
            }}</strong>
          </b-td>
          <b-td
            v-if="showEvaluationContentColumn && canViewEvaluations"
            class="text-center print-contenido"
          >
            <strong>
              {{
                $t("matterProgram.matterProgramView.hasContent").toUpperCase()
              }}
            </strong>
          </b-td>
          <b-td
            class="text-center print-horas"
            v-if="
              institution &&
              institution.internal_use_id != 'dionisioromerouniversity.com'
            "
          >
            <strong>{{
              $t(
                "matterProgram.matterProgramView.directTeachingHours"
              ).toUpperCase()
            }}</strong>
          </b-td>
          <b-td
            v-if="showAutonomousWorkHours"
            class="text-center print-horas"
          >
            <strong
              v-if="
                institution &&
                institution.internal_use_id != 'dionisioromerouniversity.com'
              "
              >{{
                $t(
                  "matterProgram.matterProgramView.autonomousWorkHours2"
                ).toUpperCase()
              }}</strong
            >
            <strong v-else>{{
              $t(
                "matterProgram.matterProgramView.chronologicalHours"
              ).toUpperCase()
            }}</strong>
          </b-td>
          <b-td
            colspan="1"
            class="text-center print-criterios"
            v-if="
              institution &&
              institution.show_evaluation_criteria_macro &&
              canViewEvaluations
            "
          >
            <strong>
              {{
                $getVisibleNames(
                  "teaching.evaluationcriteriamacro",
                  true,
                  "Criterios de Evaluación Macro"
                ).toUpperCase()
              }}</strong
            >
          </b-td>
          <b-td
            v-if="canViewEvaluations"
            colspan="1"
            class="text-center print-criterios criterios-micro-column"
          >
            <strong>
              {{
                $getVisibleNames(
                  "teaching.evaluationcriteriamicro",
                  true,
                  "Criterios de Evaluación Micro"
                ).toUpperCase()
              }}</strong
            >
          </b-td>
          <b-td
            style="width: 2%"
            v-if="allows_crud && filterMatterEvaluations.length > 0"
          ></b-td>
        </b-tr>
      </b-thead>
      <template v-for="item in filterLearningExperience">
        <template
          v-if="
            filterMatterEvaluations.filter(
              (x) => x.learning_experience == item.id
            ).length > 0
          "
        >
          <b-thead :key="'learning-experiences-1' + item.id">
            <b-tr>
              <b-th
                style="text-align: left"
                class="pl-3 evaluation-header"
                :colspan="tableColspan"
                >{{ item.name }}
              </b-th>
            </b-tr>
          </b-thead>
          <MatterProgramEvaluationDraggable
            :key="
              key_matter_program_draggable + 'learning-experiences-2' + item.id
            "
            :allows_crud="allows_crud"
            :learning_experience="item.id"
            :matter_id="matter_id"
            :egress_profile_matter_id="egress_profile_matter_id"
            :EvaluationSituations="evaluation_situations"
            :EvaluativeAgentTypes="evaluative_agent_types"
            :MatEvaStuEnvTimAll="mat_eva_stu_env_tim_all"
            :can_delete="can_delete"
            :can_update="can_update"
            :EvaluationsStatus="evaluationsStatus"
            :show_evaluation_content="showEvaluationContentColumn"
            @created_support_resource="createdSupportResource"
            @fetch_mat_eva_stu_env_tim_all="fetchMatEvaStuEnvTimAll"
          ></MatterProgramEvaluationDraggable>
          <!-- @delete_matter_evaluation="deleteMatterEvaluation" -->
          <!-- @update_matter_evaluations="
              () => $emit('update_matter_evaluations')
            " -->
        </template>
      </template>
      <template
        v-if="
          filterMatterEvaluations.filter(
            (x) => x.learning_experience == null && x.type != 5
          ).length > 0
        "
      >
        <b-thead
          :key="'learning-experiences-1.1'"
          v-if="filterLearningExperience.length > 0"
        >
          <b-tr>
            <b-th
              style="text-align: left"
              class="p-3 evaluation-header"
              :colspan="tableColspan"
            ></b-th>
          </b-tr>
        </b-thead>
        <MatterProgramEvaluationDraggable
          :key="key_matter_program_draggable + 'learning-experiences-2.1'"
          :allows_crud="allows_crud"
          :learning_experience="null"
          :include_transversal_evaluation="false"
          :matter_id="matter_id"
          :egress_profile_matter_id="egress_profile_matter_id"
          :EvaluationSituations="evaluation_situations"
          :EvaluativeAgentTypes="evaluative_agent_types"
          :MatEvaStuEnvTimAll="mat_eva_stu_env_tim_all"
          :can_delete="can_delete"
          :can_update="can_update"
          :EvaluationsStatus="evaluationsStatus"
          :show_evaluation_content="showEvaluationContentColumn"
          @created_support_resource="createdSupportResource"
          @fetch_mat_eva_stu_env_tim_all="fetchMatEvaStuEnvTimAll"
        ></MatterProgramEvaluationDraggable>
        <!-- @delete_matter_evaluation="deleteMatterEvaluation" -->
        <!-- @update_matter_evaluations="() => $emit('update_matter_evaluations')" -->
      </template>
      <b-tr
        v-if="
          institution &&
          (institution.internal_use_id == 'duoc.cl' ||
            institution.apply_transversal_exam_calculation) &&
          filterMatterEvaluations.length > 0 &&
          transversalExam
        "
      >
        <b-td class="p-3 text-right" :colspan="tableColspan">
          <strong>
            {{
              $t("matterProgram.matterProgramView.totalOfSubject", {
                percent: transversalExam
                  ? 100 - parseFloat(transversalExam.weighing)
                  : 60,
              }).toUpperCase()
            }}
          </strong>
        </b-td>
      </b-tr>
      <template
        v-if="
          filterMatterEvaluations.filter(
            (x) => x.learning_experience == null && x.type == 5
          ).length > 0
        "
      >
        <b-thead
          :key="'learning-experiences-1.2'"
          v-if="filterLearningExperience.length > 0"
        >
          <b-tr>
            <b-th
              style="text-align: left"
              class="p-3 evaluation-header"
              :colspan="tableColspan"
            ></b-th>
          </b-tr>
        </b-thead>
        <MatterProgramEvaluationDraggable
          :key="key_matter_program_draggable + 'learning-experiences-2.2'"
          :allows_crud="allows_crud"
          :learning_experience="null"
          :include_transversal_evaluation="true"
          :matter_id="matter_id"
          :egress_profile_matter_id="egress_profile_matter_id"
          :EvaluationSituations="evaluation_situations"
          :EvaluativeAgentTypes="evaluative_agent_types"
          :MatEvaStuEnvTimAll="mat_eva_stu_env_tim_all"
          :can_delete="can_delete"
          :can_update="can_update"
          :EvaluationsStatus="evaluationsStatus"
          :show_evaluation_content="showEvaluationContentColumn"
          @created_support_resource="createdSupportResource"
          @fetch_mat_eva_stu_env_tim_all="fetchMatEvaStuEnvTimAll"
        ></MatterProgramEvaluationDraggable>
        <!-- @delete_matter_evaluation="deleteMatterEvaluation" -->
        <!-- @update_matter_evaluations="() => $emit('update_matter_evaluations')" -->
      </template>
      <b-tr
        v-if="
          institution &&
          (institution.internal_use_id == 'duoc.cl' ||
            institution.apply_transversal_exam_calculation) &&
          transversalExam
        "
      >
        <b-td class="p-3 text-right" :colspan="tableColspan">
          <strong>
            {{
              $t("matterProgram.matterProgramView.totalOfSubject", {
                percent: transversalExam.weighing,
              }).toUpperCase()
            }}
          </strong>
        </b-td>
      </b-tr>
      <b-tbody v-if="filterMatterEvaluations.length == 0">
        <b-tr>
          <b-td class="text-center" :colspan="tableColspan"
            >{{
              $t(
                "matterProgram.matterProgramView.noActivitiesOrEvaluationsToShow"
              )
            }}.</b-td
          >
        </b-tr>
      </b-tbody>
    </b-table-simple>
    <ILIndicatorsUsage
      v-if="
        canViewEvaluations &&
        (filterMatterEvaluations.length > 0 || allows_crud) &&
        institution &&
        institution.internal_use_id != 'duoc.cl' &&
        institution.kl_assessment
      "
      :key="evaluation_ids.join(',')"
      :matter_id="matter_id"
      :evaluations_ids="evaluation_ids"
      :fetch_evaluations="false"
      :fetch_evaluation_criteria_micro="false"
      :fetch_competence_unit="false"
      :show_taxonomy_color="true"
    ></ILIndicatorsUsage>
    <!-- Modal: Matter → EPM por defecto; invertir = EPM → Matter -->
    <CopyEvaluationsModal
      :modal_id="`copy-epm-matter-modal-matter-${matter_id}`"
      :title="
        $t('matterProgram.matterProgramView.copyEpmMatterModalTitle', {
          entity: $getVisibleNames(
            'mesh.egressprofile',
            false,
            'Perfil de Egreso'
          ),
        })
      "
      :description="
        $t('matterProgram.matterProgramView.exportMatterToEpmDesc', {
          entity: $getVisibleNames(
            'mesh.egressprofilematter',
            false,
            'Asignatura'
          ),
          entityMatter: $getVisibleNames(
            'teaching.matter',
            false,
            'Asignatura Base'
          ),
          entityProfile: $getVisibleNames(
            'mesh.egressprofile',
            false,
            'Perfil de Egreso'
          ),
        })
      "
      :description_swapped="
        $t('matterProgram.matterProgramView.importEpmToMatterDesc', {
          entity: $getVisibleNames(
            'mesh.egressprofilematter',
            false,
            'Asignatura'
          ),
          entityMatter: $getVisibleNames(
            'teaching.matter',
            false,
            'Asignatura Base'
          ),
          entityProfile: $getVisibleNames(
            'mesh.egressprofile',
            false,
            'Perfil de Egreso'
          ),
        })
      "
      description_variant="warning"
      :swappable="true"
      :source_label="
        $getVisibleNames('teaching.matter', false, 'Asignatura Base')
      "
      :target_label="selectedEpmProfileName"
      :source_evaluations="filterMatterEvaluations"
      :source_tests="tests"
      :target_evaluations="epm_evaluations_preview"
      :target_tests="preview_tests"
      :target_loading="is_loading_preview"
      :is_copying="is_copying"
      :epm_options="availableEpmsOptions"
      :epm_required="true"
      :epm_options_loading="is_loading_matter_epms"
      :empty_epm_message="
        $t('matterProgram.matterProgramView.noEpmAvailableToCopy', {
          entity: $getVisibleNames('teaching.matter', false, 'Asignatura Base'),
          entityProfile: $getVisibleNames(
            'mesh.egressprofile',
            false,
            'Perfil de Egreso'
          ),
        })
      "
      :empty_epm_hint="
        $t('matterProgram.matterProgramView.noEpmAvailableHint', {
          entity: $getVisibleNames(
            'mesh.egressprofilematter',
            false,
            'Asignatura'
          ),
          entityProfile: $getVisibleNames(
            'mesh.egressprofile',
            false,
            'Perfil de Egreso'
          ),
          entityMatter: $getVisibleNames(
            'teaching.matter',
            false,
            'Asignatura Base'
          ),
        })
      "
      :epm_selector_label="
        $getVisibleNames('mesh.egressprofile', false, 'Perfil de Egreso')
      "
      :epm_selector_placeholder="
        $t('matterProgram.matterProgramView.selectTargetEpm', {
          entity: $getVisibleNames(
            'mesh.egressprofilematter',
            false,
            'Asignatura'
          ),
        })
      "
      @epm_selected="onEpmSelected"
      @confirmed="handleEpmMatterReplicate"
      @modal_hidden="
        selected_epm_id = null;
        epm_evaluations_preview = [];
        preview_tests = [];
      "
    ></CopyEvaluationsModal>

    <!-- Modal Crear Evaluación -->
    <b-modal
      :id="`add-matter-evaluation-modal-${matter_id}`"
      :title="$t('matterProgram.matterProgramView.createActivityOrEvaluation')"
      size="xl"
      @hide="confirmClose"
      hide-footer
    >
      <MatterProgramEvaluationForm
        :key="key_matter_program_draggable"
        :matter_id="matter_id"
        :evaluation_list="filterMatterEvaluations"
        :EvaluationSituations="evaluation_situations"
        :EvaluativeAgentTypes="evaluative_agent_types"
        :MatEvaStuEnvTimAll="mat_eva_stu_env_tim_all"
        @created="createdEvaluation"
        @created_support_resource="createdSupportResource"
        @change_matter_evaluation_form="
          () => (change_matter_evaluation_form = true)
        "
      >
      </MatterProgramEvaluationForm>
    </b-modal>
  </div>
</template>

<script>
// import draggable from "vuedraggable";
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import { activityEvaluationType } from "@/utils/instructional_activity_types";
import {
  // generateUniqueId,
  toast,
} from "@/utils/utils";
export default {
  name: "MatterProgramEvaluation",
  props: {
    matter_id: {
      type: Number,
      required: true,
    },
    allows_crud: {
      type: Boolean,
      default: false,
    },
    can_delete: {
      type: Boolean,
      default: false,
    },
    egress_profile_matter_id: {
      type: Number,
      default: null,
    },
    can_update: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    // draggable,
    MatterProgramEvaluationForm: () =>
      import("./MatterProgramEvaluationForm.vue"),
    MatterProgramEvaluationDraggable: () =>
      import("./MatterProgramEvaluationDraggable.vue"),
    // MEvaluationBibliographicResource: () =>
    //   import("./MEvaluationBibliographicResource.vue"),
    // SentenceContainer: () => import("@/components/reusable/SentenceContainer"),
    // ButtonWrapper: () => import("@/components/reusable/ButtonWrapper"),
    ILIndicatorsUsage: () =>
      import(
        "@/components/teaching/MatterProgram/Components/ILIndicatorsUsage"
      ),
    CopyEvaluationsModal: () =>
      import(
        "@/components/teaching/MatterProgram/Components/CopyEvaluationsModal"
      ),
    ButtonMedium: () =>
      import("@/components/reusable/Buttons/Medium/ButtonMedium"),
  },
  data() {
    return {
      evaluation_situations: [],
      evaluative_agent_types: [],
      mat_eva_stu_env_tim_all: [],
      prevent_close_modal: false,
      change_matter_evaluation_form: false,
      key_matter_program_draggable: 0,
      // Boton Copiar Evaluaciones
      all_matter_epms: [],
      is_loading_matter_epms: false,
      selected_epm_id: null,
      epm_evaluations_preview: [],
      is_loading_preview: false,
      is_copying: false,
      preview_tests: [],
      // Boton Copiar Evaluaciones
    };
  },
  computed: {
    ...mapGetters({
      institution: "getInstitution",
      // Boton Copiar Evaluaciones
      user: "getUser",
      egressProfiles: names.EGRESS_PROFILES,
      // Boton Copiar Evaluaciones
      egress_profiles_matters: names.EGRESS_PROFILES_MATTERS,
      evaluationCriteriasMicros: names.EVALUATION_CRITERIAS,
      studyUnits: names.STUDY_UNITS,
      learningExperiences: names.LEARNING_EXPERIENCES,
      matterEvaluations: names.MATTER_EVALUATIONS,
      evaluations: names.NEW_EVALUATIONS,
      tests: names.NEW_TESTS,
      redactionQuestions: names.NEW_REDACTION_QUESTIONS,
      multipleChoiceQuestions: names.NEW_MULTIPLE_CHOICE_QUESTIONS,
      matchingQuestions: names.NEW_MATCHING_QUESTIONS,
      rubricInstruments: names.NEW_RUBRIC_INSTRUMENTS,
      rubricCriterias: names.NEW_RUBRIC_CRITERIAS,
      work_types: names.TEST_WORK_TYPES,
    }),
    // Profesores y estudiantes no acceden a las evaluaciones desde el
    // Programa de la Asignatura (solo perfiles con gestión de mallas/carrera).
    canViewEvaluations() {
      if (!this.user || !this.user.group_names) return false;
      return !(
        this.user.group_names.includes("PROFESORES") ||
        this.user.group_names.includes("ESTUDIANTES")
      );
    },
    // Boton Copiar Evaluaciones
    availableEpmsOptions() {
      return this.all_matter_epms
        .filter((x) => !x.use_matter_values)
        .map((epm) => {
          const profile = this.egressProfiles.find(
            (p) => p.id == epm.egress_profile
          );
          const profileName = profile
            ? profile.professional_title || profile.name
            : `ID: ${epm.id}`;
          return { value: epm.id, text: profileName };
        });
    },
    selectedEpmProfileName() {
      if (!this.selected_epm_id) return "—";
      const epm = this.all_matter_epms.find(
        (x) => x.id == this.selected_epm_id
      );
      if (!epm) return "—";
      const profile = this.egressProfiles.find(
        (p) => p.id == epm.egress_profile
      );
      return profile ? profile.professional_title || profile.name : "";
    },
    // Boton Copiar Evaluaciones
    filterLearningExperience() {
      if (!this.matter_id) return [];
      return this.learningExperiences
        .filter((x) => x.matter == this.matter_id)
        .sort((a, b) => a.order - b.order);
    },
    filterMatterEvaluations() {
      if (!this.matter_id) return [];
      return this.matterEvaluations
        .filter((x) => x.matter == this.matter_id)
        .sort((a, b) => a.order - b.order);
    },
    filterEvaluations() {
      const linkedEvaluationIds = this.filterMatterEvaluations
        .filter((me) => me.evaluation != null)
        .map((me) => me.evaluation);
      return this.evaluations.filter(
        (x) =>
          x.scope == 3 &&
          x.scope_id == this.matter_id &&
          linkedEvaluationIds.includes(x.id)
      );
    },
    evaluation_ids() {
      return this.filterEvaluations.map((x) => x.id);
    },
    transversalExam() {
      return this.filterMatterEvaluations.find((x) => x.type == 5);
    },
    // Columnas fijas: nombre, tipo y ponderación; el resto (incluida descripción,
    // sólo para DUOC, y horas de trabajo autónomo, oculta para PUCV) son
    // condicionales según institución y permisos.
    showAutonomousWorkHours() {
      return !this.$hidesAutonomousWorkHours(this.institution);
    },
    // Las columnas de contenido/uso de IL dependen de la data de evaluations2,
    // que sólo se carga (y tiene sentido) cuando la institución usa KL Assessment.
    showEvaluationContentColumn() {
      return Boolean(
        this.institution &&
          this.institution.internal_use_id != "duoc.cl" &&
          this.institution.kl_assessment
      );
    },
    // DUOC asigna un único Criterio de Evaluación Micro por pregunta/dimensión
    // (FK evaluation_criteria_micro); el resto usa el M2M evaluation_criterias_micro.
    isDuocInstitution() {
      return Boolean(
        this.institution && this.institution.internal_use_id == "duoc.cl"
      );
    },
    // Las preguntas de completar (filling) quedan fuera a propósito: la vista de
    // la evaluación tampoco las suma al puntaje del instrumento.
    allQuestions() {
      return []
        .concat(this.redactionQuestions)
        .concat(this.multipleChoiceQuestions)
        .concat(this.matchingQuestions);
    },
    // { [evaluation_id]: { applies, has_content, used_ecm_ids } }
    // applies: la evaluación tiene una Evaluación de evaluations2 asociada (las
    // Actividades, type 4, no la tienen y quedan como N/A).
    evaluationsStatus() {
      let status = {};
      this.filterMatterEvaluations.forEach((evaluation) => {
        status[evaluation.id] = this.getEvaluationStatus(evaluation);
      });
      return status;
    },
    tableColspan() {
      let colspan = 3;
      if (this.showAutonomousWorkHours) colspan += 1; // Horas de Trabajo Autónomo
      if (
        this.institution &&
        (this.institution.kl_assessment ||
          this.institution.internal_use_id == "duoc.cl")
      )
        colspan += 1; // Instrumentos / Situación Evaluativa
      if (this.isDuocInstitution) colspan += 1; // Descripción
      if (this.showEvaluationContentColumn) colspan += 1; // Contenido
      if (
        this.institution &&
        this.institution.internal_use_id != "dionisioromerouniversity.com"
      )
        colspan += 1; // Horas de Docencia Directa
      if (this.institution && this.institution.show_evaluation_criteria_macro)
        colspan += 1; // Criterios de Evaluación Macro
      colspan += 1; // Criterios de Evaluación Micro
      if (this.allows_crud) colspan += 1; // Acciones
      if (this.allows_crud && this.can_update) colspan += 1; // Handle de arrastre
      return colspan;
    },
  },
  methods: {
    // Criterios de Evaluación Micro asignados a una pregunta o dimensión de pauta.
    getItemECMicroIds(item) {
      if (this.isDuocInstitution)
        return item.evaluation_criteria_micro != null
          ? [item.evaluation_criteria_micro]
          : [];
      return item.evaluation_criterias_micro || [];
    },
    // Un instrumento está completo cuando su contenido cubre el total definido:
    // - preguntas: la suma de sus puntajes iguala el puntaje del instrumento.
    // - pautas: la suma de las ponderaciones de sus dimensiones es 100%.
    isTestComplete(test, questions, rubrics, rubric_criterias) {
      const test_questions = questions.filter((x) => x.test == test.id);
      const test_rubrics = rubrics.filter((x) => x.test == test.id);
      if (test_questions.length == 0 && test_rubrics.length == 0) return false;
      if (test_questions.length > 0) {
        const questions_max_score = this.$round(
          test_questions.reduce(
            (acc, x) => acc + parseFloat(x.max_score || 0),
            0
          )
        );
        if (
          !(parseFloat(test.max_score) > 0) ||
          questions_max_score != this.$round(parseFloat(test.max_score))
        )
          return false;
      }
      if (test_rubrics.length > 0) {
        // En la práctica es una pauta por instrumento, pero si hubiera más se
        // exigen todas completas en vez de mirar sólo la primera.
        const rubrics_are_complete = test_rubrics.every((rubric) => {
          const criterias = rubric_criterias.filter(
            (x) => x.rubric == rubric.id
          );
          if (criterias.length == 0) return false;
          const total_weighing = this.$round(
            criterias.reduce((acc, x) => acc + Number(x.weighing || 0), 0)
          );
          return total_weighing == 100;
        });
        if (!rubrics_are_complete) return false;
      }
      return true;
    },
    getEvaluationStatus(evaluation) {
      const empty = { applies: false, has_content: false, used_ecm_ids: [] };
      if (!this.showEvaluationContentColumn) return empty;
      if (evaluation.evaluation == null) return empty;
      const tests = this.tests.filter(
        (x) => x.evaluation == evaluation.evaluation
      );
      const test_ids = tests.map((x) => x.id);
      const questions = this.allQuestions.filter((x) =>
        test_ids.includes(x.test)
      );
      const rubrics = this.rubricInstruments.filter((x) =>
        test_ids.includes(x.test)
      );
      const rubric_ids = rubrics.map((x) => x.id);
      const rubric_criterias = this.rubricCriterias.filter((x) =>
        rubric_ids.includes(x.rubric)
      );
      let used_ecm_ids = [];
      questions.forEach((question) => {
        used_ecm_ids = used_ecm_ids.concat(this.getItemECMicroIds(question));
      });
      rubric_criterias.forEach((rubric_criteria) => {
        used_ecm_ids = used_ecm_ids.concat(
          this.getItemECMicroIds(rubric_criteria)
        );
      });
      return {
        applies: true,
        has_content:
          tests.length > 0 &&
          tests.every((test) =>
            this.isTestComplete(test, questions, rubrics, rubric_criterias)
          ),
        used_ecm_ids: [...new Set(used_ecm_ids)],
      };
    },
    // Carga la data de evaluations2 necesaria para calcular el uso de Criterios
    // de Evaluación Micro y si la evaluación tiene contenido. La consume también
    // ILIndicatorsUsage, por eso se hace acá una sola vez.
    fetchEvaluationsContent(tests) {
      if (!this.showEvaluationContentColumn) return;
      const tests_ids = tests.map((x) => x.id);
      if (tests_ids.length == 0) return;
      this.$store.dispatch(names.FETCH_NEW_TEST_SEGMENTS, {
        tests_ids: tests_ids,
      });
      this.$store.dispatch(names.FETCH_NEW_REDACTION_QUESTIONS, {
        tests_ids: tests_ids,
      });
      this.$store.dispatch(names.FETCH_NEW_MULTIPLE_CHOICE_QUESTIONS, {
        tests_ids: tests_ids,
      });
      this.$store.dispatch(names.FETCH_NEW_FILLING_QUESTIONS, {
        tests_ids: tests_ids,
      });
      this.$store.dispatch(names.FETCH_NEW_MATCHING_QUESTIONS, {
        tests_ids: tests_ids,
      });
      // FETCH_NEW_RUBRIC_INSTRUMENTS despacha además la carga de las dimensiones
      // (NEW_RUBRIC_CRITERIAS) de cada pauta.
      this.$store.dispatch(names.FETCH_NEW_RUBRIC_INSTRUMENTS, {
        tests_ids: tests_ids,
      });
    },
    // Copiar evaluaciones
    openEpmMatterModal() {
      this.fetchAllMatterEpms();
      this.$bvModal.show(`copy-epm-matter-modal-matter-${this.matter_id}`);
    },
    fetchAllMatterEpms() {
      if (this.all_matter_epms.length > 0) return;
      this.is_loading_matter_epms = true;
      this.$restful
        .GetAll(`/mesh/egress-profile-matter/?matter=${this.matter_id}`)
        .then((response) => {
          this.all_matter_epms = response;
          const loadedProfileIds = this.egressProfiles.map((p) => p.id);
          const missingIds = [
            ...new Set(response.map((epm) => epm.egress_profile)),
          ].filter((id) => !loadedProfileIds.includes(id));
          missingIds.forEach((id) => {
            this.$store.dispatch(names.FETCH_EGRESS_PROFILE, id);
          });
        })
        .finally(() => {
          this.is_loading_matter_epms = false;
        });
    },
    onEpmSelected(epmId) {
      this.selected_epm_id = epmId;
      this.fetchEpmEvaluationsPreview(epmId);
    },
    fetchEpmEvaluationsPreview(epmId) {
      if (!epmId) return;
      this.is_loading_preview = true;
      this.epm_evaluations_preview = [];
      this.preview_tests = [];
      this.$restful
        .GetAll(
          `/teaching/egress-profile-matter-evaluation/?egress_profile_matter=${epmId}`
        )
        .then((response) => {
          this.epm_evaluations_preview = response.sort(
            (a, b) => a.order - b.order
          );
          const evaluationIds = response
            .filter((x) => x.evaluation != null)
            .map((x) => x.evaluation);
          if (evaluationIds.length > 0) {
            this.$store
              .dispatch(names.FETCH_NEW_TESTS, {
                evaluations_ids: evaluationIds,
              })
              .then((tests) => {
                const existingIds = this.preview_tests.map((t) => t.id);
                tests.forEach((t) => {
                  if (!existingIds.includes(t.id)) this.preview_tests.push(t);
                });
              });
          }
        })
        .finally(() => {
          this.is_loading_preview = false;
        });
    },
    handleEpmMatterReplicate({ source_items, target_updates, is_swapped }) {
      if (!this.selected_epm_id) return;
      this.is_copying = true;
      // Sin invertir: Matter (source) → EPM (target) = exportar
      // Invertido:    EPM (source) → Matter (target) = importar
      const payload = is_swapped
        ? {
            target_matter: this.matter_id,
            matter_evaluations_to_update: target_updates,
            epm_evaluations_to_replicate: source_items,
          }
        : {
            target_epm: this.selected_epm_id,
            epm_evaluations_to_update: target_updates,
            matter_evaluations_to_replicate: source_items,
          };
      this.$restful
        .Post("/mesh/replicate_evaluations/", payload)
        .then(() => {
          toast(
            this.$t("matterProgram.matterProgramView.copyEvaluationsSuccess")
          );
          if (is_swapped) {
            // EPM → Matter: eliminar del store las evaluaciones borradas, luego recargar
            target_updates
              .filter((item) => item.to_delete)
              .forEach((item) => {
                this.$store.commit(
                  names.MUTATE_DELETE_MATTER_EVALUATION,
                  item.id
                );
              });
            this.$store
              .dispatch(names.FETCH_MATTER_EVALUATIONS, this.matter_id)
              .then((matter_evaluations) => {
                const evaluations_ids = matter_evaluations
                  .filter((x) => x.evaluation != null)
                  .map((x) => x.evaluation);
                if (evaluations_ids.length > 0) {
                  this.$store.dispatch(names.FETCH_NEW_EVALUATIONS, {
                    evaluations_ids: evaluations_ids,
                  });
                  this.$store
                    .dispatch(names.FETCH_NEW_TESTS, {
                      evaluations_ids: evaluations_ids,
                    })
                    .then((tests) => {
                      this.fetchEvaluationsContent(tests);
                    });
                }
              });
          } else {
            // Matter → EPM: notificar al padre para que recargue el EPM
            this.$emit("update_matter_evaluations");
          }
          this.$bvModal.hide(`copy-epm-matter-modal-matter-${this.matter_id}`);
        })
        .catch(() => {
          toast(
            this.$t("matterProgram.matterProgramView.copyEvaluationsError")
          );
        })
        .finally(() => {
          this.is_copying = false;
        });
    },
    // Boton Copiar Evaluaciones
    createdSupportResource(response) {
      this.$emit("created_support_resource", response);
    },
    confirmClose(bvModalEvt) {
      if (
        bvModalEvt.trigger === "headerclose" ||
        bvModalEvt.trigger === "event"
      ) {
        this.change_matter_evaluation_form = false;
        return;
      }
      if (!this.prevent_close_modal && this.change_matter_evaluation_form) {
        bvModalEvt.preventDefault();
        this.$bvModal
          .msgBoxConfirm(
            this.$t("matterProgram.matterProgramView.unsavedDataWillBeLost") +
              ".",
            {
              title: this.$t(
                "matterProgram.matterProgramView.confirmationRequired"
              ),
              size: "md",
              buttonSize: "md",
              okVariant: "warning",
              okTitle: this.$t("matterProgram.matterProgramView.yesClose"),
              cancelTitle: this.$t("reusable.common.cancel"),
              footerClass: "p-2",
              hideHeaderClose: true,
              centered: true,
              headerClass: "text-black",
              header: {
                title: this.$t(
                  "matterProgram.matterProgramView.confirmationRequired"
                ),
                class: "text-center",
              },
            }
          )
          .then((value) => {
            if (value) {
              this.prevent_close_modal = true;
              this.$bvModal.hide(bvModalEvt.componentId);
              this.$nextTick(() => {
                this.change_matter_evaluation_form = false;
                this.prevent_close_modal = false;
              });
            }
          });
      }
    },
    createdNewEvaluation(response, tests_list) {
      this.$store
        .dispatch(names.POST_NEW_EVALUATION, {
          title: response.name,
          description: response.description,
          weighing: response.weighing,
          visible_by_evaluatees: false,
          parent_evaluation: null,
          files: [],
        })
        .then((new_evaluation) => {
          this.$store.commit(
            "MUTATE_CHANGE_NEW_EVALUATION_BY_MATTER_EVALUATION",
            {
              new_evaluation_id: new_evaluation.id,
              matter_evaluation_id: response.id,
            }
          );
          this.$restful
            .Post("/evaluations2/evaluation-scope-default/", {
              scope: 3,
              scope_id: this.matter_id,
              evaluation: new_evaluation.id,
            })
            .then((evaluation_scope) => {
              this.$store.commit(
                "MUTATE_CHANGE_NEW_EVALUATION_SCOPE_BY_NEW_EVALUATION",
                evaluation_scope
              );
              response.evaluation = new_evaluation.id;
              this.$store
                .dispatch(names.PATCH_MATTER_EVALUATION, {
                  matter_evaluation_id: response.id,
                  item: { evaluation: new_evaluation.id },
                })
                .then(() => {
                  this.bulkCreateTest(tests_list, new_evaluation);
                });
              // evaluation_type:  diagnóstica 1, formativa 2, sumativa 3, actividad 4, transversal 5
              // evaluations2: sumativa 1, diagnóstica 2, formativa 3, trasnversal 4
              let evaluation_type = null;
              // diagnóstica 1 => diagnóstica 2
              if (response.type == 1) evaluation_type = 2;
              // formativa 2 => formativa 3
              else if (response.type == 2) evaluation_type = 3;
              // actividad 4: el tipo visible es "Actividad" y Formativa/Sumativa
              // es su subtipo, que se deduce de si pondera. Mismo criterio que
              // el "¿Posee Ponderación?" del Diseño Instruccional.
              else if (response.type == 4)
                evaluation_type = activityEvaluationType(response.weighing);
              // sumativa 3 => sumativa 1
              else if (response.type == 3) evaluation_type = 1;
              // trasnversal 5 => trasnversal 4
              else if (response.type == 5) evaluation_type = 4;
              // formativa 3
              else evaluation_type = 3;
              this.saveEvaluationTypeDefault(new_evaluation, {
                id: new_evaluation.evaluation_type_default,
                type: evaluation_type,
                evaluation: new_evaluation.id,
              });
              // this.$nextTick(() => {
              //   this.$bvModal.show(
              //     `m-bibliographic-resource-modal-${response.id}`
              //   );
              // });
            });
        });
    },
    createdEvaluation(evaluation, tmp_mat_eva_stu_env_tim_alls, tests_list) {
      evaluation.order =
        this.filterMatterEvaluations.filter(
          (x) => x.learning_experience == evaluation.learning_experience
        ).length + 1;
      this.$store
        .dispatch(names.POST_MATTER_EVALUATION, evaluation)
        .then((response) => {
          // El tipo "Actividad" ya no se salta la creacion del Evaluation: sin
          // el no hay donde colgar los Test ni a donde llevar el click de la
          // fila. Es lo que le da a la Actividad la misma funcionalidad que al
          // resto de las evaluaciones.
          if (response.evaluation == null) {
            this.createdNewEvaluation(response, tests_list);
          } else {
            if (response.evaluation != null) {
              this.$store
                .dispatch(names.PATCH_NEW_EVALUATION, {
                  new_evaluation_id: response.evaluation,
                  item: {
                    title: response.name,
                    description: response.description,
                    weighing: response.weighing,
                  },
                })
                .then((new_evaluation) => {
                  this.$store.commit(
                    names.MUTATE_NEW_EVALUATION,
                    new_evaluation
                  );
                  this.bulkCreateTest(tests_list, new_evaluation);
                });
            }
            // this.$nextTick(() => {
            //   this.$bvModal.show(
            //     `m-bibliographic-resource-modal-${response.id}`
            //   );
            // });
          }
          this.createdMatStuEnvTimAlls(response, tmp_mat_eva_stu_env_tim_alls);
          this.$bvModal.hide(`add-matter-evaluation-modal-${this.matter_id}`);
        });
    },
    async createdMatStuEnvTimAlls(evaluation, tmp_mat_eva_stu_env_tim_alls) {
      for await (let tmp_map_eva of tmp_mat_eva_stu_env_tim_alls) {
        this.$restful
          .Post(`/mesh/mat-eva-stu-env-tim-all/`, {
            matter_evaluation: evaluation.id,
            study_environment: tmp_map_eva.study_environment,
            time_allocation: tmp_map_eva.time_allocation,
            hours: tmp_map_eva.hours,
          })
          .then((response) => {
            this.mat_eva_stu_env_tim_all.push(response);
          });
      }
    },
    async bulkCreateTest(test_list, new_evaluation) {
      for await (let test of test_list) {
        if (isNaN(test.id)) {
          test.evaluation = new_evaluation.id;
          if (this.institution && this.institution.internal_use_id == "duoc.cl")
            test.title = new_evaluation.title;
          await this.$store
            .dispatch(names.POST_NEW_TEST, test)
            .then((new_test) => {
              this.saveTestType({
                ...new_test,
                instrument_type: test.instrument_type,
              });
            });
        } else if (!test.delete_test) {
          await this.$store
            .dispatch(names.PATCH_NEW_TEST, {
              new_test_id: test.id,
              item: {
                title: test.title,
                evaluation_situation: test.evaluation_situation,
                weighing: test.weighing,
                examiner: test.examiner,
                work_type: test.work_type,
                authentic_evaluation: test.authentic_evaluation,
              },
            })
            .then((new_test) => {
              this.saveTestType({
                ...new_test,
                instrument_type: test.instrument_type,
              });
            });
        } else if (test.delete_test) {
          await this.$store.dispatch(names.DELETE_NEW_TEST, test.id);
        }
      }
    },
    saveTestType(new_test) {
      if (new_test.test_type_default == null) {
        this.$restful
          .Post("/evaluations2/test-type-default/", {
            test: new_test.id,
            evaluative_agent: new_test.instrument_type.evaluative_agent,
          })
          .then((response) => {
            this.$store.commit(
              "MUTATE_CHANGE_NEW_TEST_TYPES_BY_NEW_TEST",
              response
            );
          });
      } else {
        this.$restful
          .Put(
            `/evaluations2/test-type-default/${new_test.test_type_default}/`,
            {
              test: new_test.id,
              evaluative_agent: new_test.instrument_type.evaluative_agent,
            }
          )
          .then((response) => {
            this.$store.commit(
              "MUTATE_CHANGE_NEW_TEST_TYPES_BY_NEW_TEST",
              response
            );
          });
      }
    },
    saveEvaluationTypeDefault(new_evaluation, evaluation_type) {
      if (evaluation_type) {
        if (new_evaluation.evaluation_type_default == null) {
          this.$restful
            .Post("/evaluations2/evaluation-type-default/", evaluation_type)
            .then((response) => {
              this.$store.commit(
                "MUTATE_CHANGE_NEW_EVALUATION_TYPE_BY_NEW_EVALUATION",
                response
              );
            });
        } else {
          this.$restful
            .Put(
              `/evaluations2/evaluation-type-default/${evaluation_type.id}/`,
              evaluation_type
            )
            .then((response) => {
              this.$store.commit(
                "MUTATE_CHANGE_NEW_EVALUATION_TYPE_BY_NEW_EVALUATION",
                response
              );
            });
        }
      }
    },
    updatedEvaluation(evaluation) {
      this.$store
        .dispatch(names.UPDATE_MATTER_EVALUATION, evaluation)
        .then((response) => {
          this.$bvModal.hide(`edit-matter-evaluation-modal-${response.id}`);
        });
    },
    fetchMatEvaStuEnvTimAll() {
      if (this.mat_eva_stu_env_tim_all.length == 0)
        this.$restful
          .GetAll(`/mesh/mat-eva-stu-env-tim-all/?matter=${this.matter_id}`)
          .then((response) => {
            this.mat_eva_stu_env_tim_all = response;
            this.key_matter_program_draggable++;
          });
      else {
        const time = setInterval(() => {
          this.$restful
            .GetAll(`/mesh/mat-eva-stu-env-tim-all/?matter=${this.matter_id}`)
            .then((response) => {
              this.mat_eva_stu_env_tim_all = response;
              this.key_matter_program_draggable++;
            });
          clearInterval(time);
        }, 500);
      }
    },
    fetchEvaluationSituations() {
      this.$restful
        .GetAll(`/teaching/evaluation-situation/`)
        .then((response) => {
          this.evaluation_situations = response;
        });
    },
    fetchEvaluativeAgentTypes() {
      this.$restful.GetAll(`/teaching/evaluative-agent/`).then((response) => {
        this.evaluative_agent_types = response;
      });
    },
    totalWeighingByWorkType(work_type_id) {
      const evaluations = this.filterEvaluations.filter((x) => x.weighing > 0);
      const tests = this.tests.filter(
        (x) =>
          evaluations.map((e) => e.id).includes(x.evaluation) &&
          x.work_type == work_type_id
      );
      return tests.reduce((acc, obj) => {
        const evaluation = evaluations.find((x) => x.id == obj.evaluation);
        let evaluation_weighing = 0;
        if (evaluation) {
          evaluation_weighing = parseFloat(evaluation.weighing);
          // if (evaluation.type == 1)
          //   evaluation_weighing = parseFloat(evaluation_weighing) * 0.6;
          // evaluation.type == 1 sumativa
          if (evaluation.type == 1 && this.transversalExam)
            evaluation_weighing = parseFloat(evaluation_weighing) * 0.6;
          // evaluation.type == 5 trasnversal
          if (evaluation.type == 5)
            evaluation_weighing = parseFloat(evaluation_weighing) * 0.4;
        }
        return (
          parseFloat(acc) +
          (parseFloat(obj.weighing) * parseFloat(evaluation_weighing)) / 100
        );
      }, 0);
    },
  },
  created() {
    this.$store.dispatch(names.FETCH_EPM_EVALUATION_TYPES);
    this.$store.dispatch(names.FETCH_AUTONOMOUS_TEACHING_ACTIVITIES);
    // Las evaluaciones de la asignatura se cargan siempre. La cascada
    // tests -> instrumentos (NewEvaluation/NewTest) es solo para roles que
    // gestionan el programa (no PROFESORES/ESTUDIANTES). Un solo request por
    // endpoint, encadenado, no repetido por cada instrumento.
    this.$store
      .dispatch(names.FETCH_MATTER_EVALUATIONS, this.matter_id)
      .then((matter_evaluations) => {
        if (!this.canViewEvaluations) return;
        const evaluations_ids = matter_evaluations
          .filter((x) => x.evaluation != null)
          .map((x) => x.evaluation);
        if (evaluations_ids.length > 0) {
          this.$store.dispatch(names.FETCH_NEW_EVALUATIONS, {
            evaluations_ids: evaluations_ids,
          });
          this.$store.dispatch(names.FETCH_NEW_TESTS, {
            evaluations_ids: evaluations_ids,
          });
          this.$store
            .dispatch(names.FETCH_NEW_TESTS, {
              evaluations_ids: evaluations_ids,
            })
            .then((tests) => {
              this.fetchEvaluationsContent(tests);
            });
        }
      });
    this.$store.dispatch(names.FETCH_NEW_TEST_TYPES);
    this.$store.dispatch(names.FETCH_TEST_WORK_TYPES);
    this.fetchMatEvaStuEnvTimAll();
    this.fetchEvaluativeAgentTypes();
    this.fetchEvaluationSituations();
  },
};
</script>

<style scoped src="@/utils/rich_text_editor.css">
</style>
<style scoped>
table th {
  vertical-align: middle;
  background-color: var(--kl-color-accent-medium) !important;
  color: var(--kl-text-on-primary);
  font-size: var(--primary-font-size);
  padding: 2px 2px;
}
.work-type-th {
  border: 1px solid var(--kl-table-border) !important;
  color: var(--kl-text-on-primary);
  padding: 3px 10px 3px 10px;
  text-align: center;
}
.work-type-td {
  text-align: center;
  padding: 3px 10px 3px 10px;
}
.evaluation-header {
  color: var(--kl-text-on-primary) !important;
  background: var(--kl-color-accent-medium) !important;
  border: 1px solid var(--kl-table-border) !important;
}
.evaluation-button-div {
  float: right;
  /* padding-right: 1rem; */
}
table td {
  border: 1px solid var(--kl-table-border) !important;
  text-align: left;
  vertical-align: middle;
  font-size: var(--secondary-font-size);
  padding: 2px 2px;
}
.grabbable {
  cursor: grab;
  cursor: -moz-grab;
  cursor: -webkit-grab;
}
.grabbable:active {
  cursor: grabbing;
  cursor: -moz-grabbing;
  cursor: -webkit-grabbing;
}
.ec-badge-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
}
.ec-micro-badge {
  font-size: var(--thirth-font-size);
  text-align: center;
  width: fit-content !important;
  margin-right: 0.3em;
}
@media print {
  .ec-micro-badge {
    border: none;
  }

  /* Clases específicas para impresión */
  .print-nombre {
    width: 120px !important;
  }
  .print-instrumento {
    width: 100px !important;
  }
  .print-descripcion {
    width: auto !important;
    min-width: 200px !important;
  }
  .print-tipo {
    width: 60px !important;
  }
  .print-ponderacion {
    width: 80px !important;
  }
  .print-horas {
    width: 120px !important;
  }
  .print-criterios {
    width: 100px !important;
  }

  /* Eliminar scroll y ajustar tablas para impresión */
  .table-responsive {
    overflow: visible !important;
  }

  .b-table-simple {
    overflow: visible !important;
    width: 100% !important;
  }

  /* Ajustar contenido de descripción */
  .description-evaluation {
    overflow: visible !important;
    max-height: none !important;
    word-wrap: break-word !important;
  }

  /* Ajustar tablas dentro de descripción */
  .description-evaluation table {
    width: 100% !important;
    table-layout: fixed !important;
    font-size: 10px !important;
  }

  .description-evaluation table td,
  .description-evaluation table th {
    word-wrap: break-word !important;
    overflow-wrap: break-word !important;
    hyphens: auto !important;
    padding: 2px !important;
  }
}
</style>